import React from 'react';
import Menu from './Menu';

function SubmenuText({children}: {children: React.ReactNode}) {
    return (
        <Menu sx={{
            '&::before': {
                content: '"·"',
                position: 'absolute',
                left: 0,
                top: 0,
            },
            '@media screen and (min-width: 1200px)': {
                fontSize: '14px',
                lineHeight: 1.71,
            },
        }}>
            {children}
        </Menu>
    );
}

export default SubmenuText;
